"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _BaseButton = _interopRequireDefault(require("../BaseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: white;\n\tborder: ", " solid white;\n\tbackground-color: transparent;\n\n\t&:hover {\n\t\tcolor: ", ";\n\t\tborder-color: ", ";\n\t\tbackground-color: transparent;\n\t}\n\n\t&:disabled {\n\t\tbackground-color: transparent !important;\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var white = (0, _styledComponents.css)(_templateObject(), _vars.default.borderWidth, _colors.default.outlineHover, _colors.default.outlineHover, _colors.default.grey);
var color = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return "\n\t\tcolor: " + _colors.default[props.color] + ";\n\t\tborder: " + _vars.default.borderWidth + " solid " + _colors.default[props.color] + ";\n\t\tbackground-color: " + _colors.default.white + ";\n\n\t\t&:hover {\n\t\t\tbackground: " + _colors.default[props.color + "Dark"] + ";\n\t\t\tborder-color: " + _colors.default[props.color + "Dark"] + ";\n\t\t\tcolor: " + _colors.default.white + ";\n\t\t}\n\n\t\t&:disabled {\n\t\t\tbackground-color: transparent !important;\n\t\t\tcolor: " + _colors.default.grey + " !important;\n\t\t}\n\t";
});
var OutlineButton = (0, _styledComponents.default)(_BaseButton.default)(_templateObject3(), function (props) {
  return props.color === 'white' ? white : color;
});
OutlineButton.displayName = 'OutlineButton';
OutlineButton.propTypes = {
  color: (0, _propTypes.oneOf)(['primary', 'secondary', 'white'])
};
OutlineButton.defaultProps = {
  color: 'secondary'
};
/** @component */

var _default = OutlineButton;
exports.default = _default;